import packageJson from '/package.json';

const GROUP_MIN_ZOOM = 7.5;
const GROUP_MAX_ZOOM = 20;
const GROUP_BASE_OPACITY = 0.5;

// 林地開発 - 連絡調整 レイヤー一覧
const layers = [];

layers.push(
  // 林地開発 - 連絡調整 ポリゴン
  {
    id: "shizuoka-林地開発-連絡調整",
    type: "fill",
    source: "shizuokaRinchiKaihatsuRenrakuChouseiSource",
    "source-layer": "MAGIS.RINCHI_KAIHATSU_RENRAKU_CHOUSEI",
    minzoom: GROUP_MIN_ZOOM,
    maxzoom: GROUP_MAX_ZOOM,
    paint: {
      "fill-color": "#993300",
    },
    metadata: {
      baseOpacity: GROUP_BASE_OPACITY
    }
  },
  // 林地開発 - 連絡調整(ハイライト) ポリゴン
  {
    id: "shizuoka-林地開発-連絡調整-hilight",
    type: "fill",
    source: "shizuokaRinchiKaihatsuRenrakuChouseiSource",
    "source-layer": "MAGIS.RINCHI_KAIHATSU_RENRAKU_CHOUSEI",
    minzoom: GROUP_MIN_ZOOM,
    maxzoom: GROUP_MAX_ZOOM,
    filter: [
      "all",
      false,
    ],
    paint: {
      "fill-color": "rgba(255, 255, 0, 0.4)",
    },
    layout: {
      visibility: "none"
    },
    metadata: {
      baseOpacity: GROUP_BASE_OPACITY
    }
  },
);

const tilesPath =
    import.meta.env.VITE_SHIZUOKA_MVT_ENDPOINT +
    "/MAGIS.RINCHI_KAIHATSU_RENRAKU_CHOUSEI/{z}/{x}/{y}.pbf" +
    "?" + packageJson.lastupdate

const shizuokaRinchiKaihatsuRenrakuChousei = {
  layers: layers,
  source: {
    type: "vector",
    tiles: [tilesPath],
    minzoom: 4,
    maxzoom: 18
  }
};

export default shizuokaRinchiKaihatsuRenrakuChousei;
